import { render, staticRenderFns } from "./completeFormatting.vue?vue&type=template&id=dc5779c4"
import script from "./completeFormatting.vue?vue&type=script&lang=js"
export * from "./completeFormatting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports